module.exports = __webpack_public_path__ + "img/JM.d42981c7.svg";